// import React, { Component } from 'react'

// class Divisionservice extends Component {
//     render() {
//         return (
//             <div className="d-flex justify-content-center gap-3" style={{ marginTop: "80px" }}>
//                 <div className="card text-center rounded-5" style={{ width: "18rem", position: "relative", paddingTop: "50px" }}>
//                     <img
//                         src="/fastfood.png"
//                         className="rounded-circle"
//                         alt="Profile"
//                         style={{
//                             width: "110px",
//                             height: "110px",
//                             objectFit: "cover",
//                             position: "absolute",
//                             top: "-55px",
//                             left: "50%",
//                             transform: "translateX(-50%)",
//                         }}
//                     />
//                     <div
//                         className="card-body text-start" style={{ padding: "20px" }}>
//                         <h5 className="card-title text-center mt-1 fw-bold fs-6">Food and Beverage Division</h5>
//                         <p className="card-text ps-4 mt-3 mb-1 text-muted">Waiter</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Waitress</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Receptionist</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Bartender</p>
//                         <p className="card-text ps-4 mb-3 text-muted">Barista</p>

//                     </div>
//                 </div>

//                 <div className="card text-center rounded-5" style={{ width: "18rem", position: "relative", paddingTop: "50px" }}>
//                     <img
//                         src="/kitchen.png"
//                         className="rounded-circle"
//                         alt="Profile"
//                         style={{
//                             width: "110px",
//                             height: "110px",
//                             objectFit: "cover",
//                             position: "absolute",
//                             top: "-55px",
//                             left: "50%",
//                             transform: "translateX(-50%)",
//                         }}
//                     />
//                     <div
//                         className="card-body text-start" style={{ padding: "20px" }}>
//                         <h5 className="card-title text-center mt-1 fw-bold fs-6">Kitchen Division</h5>
//                         <p className="card-text ps-4 mt-3 mb-1 text-muted">Kitchen Helper (Hot/Cold)</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Butcher</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Pastry</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Baker</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Stewards</p>

//                     </div>
//                 </div>

//                 <div className="card text-center rounded-5" style={{ width: "18rem", position: "relative", paddingTop: "50px" }}>
//                     <img
//                         src="/housekeeping.png"
//                         className="rounded-circle"
//                         alt="Profile"
//                         style={{
//                             width: "110px",
//                             height: "110px",
//                             objectFit: "cover",
//                             position: "absolute",
//                             top: "-55px",
//                             left: "50%",
//                             transform: "translateX(-50%)",
//                         }}
//                     />
//                     <div
//                         className="card-body text-start" style={{ padding: "20px" }}>
//                         <h5 className="card-title text-center mt-1 fw-bold fs-6">Housekeeping Division</h5>
//                         <p className="card-text ps-4 mt-3 mb-1 text-muted">Room Attendant</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Public Area Attendant</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Laundry Attendant</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Linen/Uniform Attendant</p>
//                         <p className="card-text ps-4 mt-1 mb-1 text-muted">Bellman</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Valet Parker</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Telephone Operator</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Reservations Agent</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Gym/Pool Attendant</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Lobby Greeter</p>

//                     </div>
//                 </div>

//                 <div className="card text-center rounded-5" style={{ width: "18rem", position: "relative", paddingTop: "50px" }}>
//                     <img
//                         src="/adminskill.png"
//                         className="rounded-circle"
//                         alt="Profile"
//                         style={{
//                             width: "110px",
//                             height: "110px",
//                             objectFit: "cover",
//                             position: "absolute",
//                             top: "-55px",
//                             left: "50%",
//                             transform: "translateX(-50%)",
//                         }}
//                     />
//                     <div
//                         className="card-body text-start" style={{ padding: "20px" }}>
//                         <h5 className="card-title text-center mt-1 fw-bold fs-6">Skilled and Admin Division</h5>
//                         <p className="card-text ps-4 mt-3 mb-1 text-muted">Engineering Staff</p>
//                         <p className="card-text ps-4 mb-1 text-muted">• Carpenter</p>
//                         <p className="card-text ps-4 mb-1 text-muted">• Painter</p>
//                         <p className="card-text ps-4 mb-1 text-muted">• AC Technician</p>
//                         <p className="card-text ps-4 mt-1 mb-1 text-muted">• Electrician</p>
//                         <p className="card-text ps-4 mb-1 text-muted">• Mason</p>
//                         <p className="card-text ps-4 mb-1 text-muted">• Plumber</p>
//                         <p className="card-text ps-4 mb-1 text-muted">• Driver</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Accounting/Finance Staff</p>
//                         <p className="card-text ps-4 mb-1 text-muted">HR Staff</p>
//                         <p className="card-text ps-4 mb-1 text-muted">Admin Staff</p>

//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }
// export default Divisionservice;
// import React, { Component } from "react";

// class Divisionservice extends Component {
//   render() {
//     return (
//       <div className="container mt-5">
//         <div className="row g-4 justify-content-center">
//           {/* Food and Beverage Division */}
//           <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//             <div className="card text-center rounded-5 position-relative p-4">
//               <img
//                 src="/fastfood.png"
//                 className="rounded-circle"
//                 alt="Profile"
//                 style={{
//                   width: "100px",
//                   height: "100px",
//                   objectFit: "cover",
//                   position: "absolute",
//                   top: "-50px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                 }}
//               />
//               <div className="card-body text-start">
//                 <h5 className="card-title text-center mt-3 fw-bold fs-6">
//                   Food and Beverage Division
//                 </h5>
//                 <p className="card-text text-muted">Waiter</p>
//                 <p className="card-text text-muted">Waitress</p>
//                 <p className="card-text text-muted">Receptionist</p>
//                 <p className="card-text text-muted">Bartender</p>
//                 <p className="card-text text-muted">Barista</p>
//               </div>
//             </div>
//           </div>

//           {/* Kitchen Division */}
//           <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//             <div className="card text-center rounded-5 position-relative p-4">
//               <img
//                 src="/kitchen.png"
//                 className="rounded-circle"
//                 alt="Profile"
//                 style={{
//                   width: "100px",
//                   height: "100px",
//                   objectFit: "cover",
//                   position: "absolute",
//                   top: "-50px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                 }}
//               />
//               <div className="card-body text-start">
//                 <h5 className="card-title text-center mt-3 fw-bold fs-6">
//                   Kitchen Division
//                 </h5>
//                 <p className="card-text text-muted">
//                   Kitchen Helper (Hot/Cold)
//                 </p>
//                 <p className="card-text text-muted">Butcher</p>
//                 <p className="card-text text-muted">Pastry</p>
//                 <p className="card-text text-muted">Baker</p>
//                 <p className="card-text text-muted">Stewards</p>
//               </div>
//             </div>
//           </div>

//           {/* Housekeeping Division */}
//           <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//             <div className="card text-center rounded-5 position-relative p-4">
//               <img
//                 src="/housekeeping.png"
//                 className="rounded-circle"
//                 alt="Profile"
//                 style={{
//                   width: "100px",
//                   height: "100px",
//                   objectFit: "cover",
//                   position: "absolute",
//                   top: "-50px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                 }}
//               />
//               <div className="card-body text-start">
//                 <h5 className="card-title text-center mt-3 fw-bold fs-6">
//                   Housekeeping Division
//                 </h5>
//                 <p className="card-text text-muted">Room Attendant</p>
//                 <p className="card-text text-muted">Public Area Attendant</p>
//                 <p className="card-text text-muted">Laundry Attendant</p>
//                 <p className="card-text text-muted">Linen/Uniform Attendant</p>
//                 <p className="card-text text-muted">Bellman</p>
//                 <p className="card-text text-muted">Valet Parker</p>
//                 <p className="card-text text-muted">Telephone Operator</p>
//                 <p className="card-text text-muted">Reservations Agent</p>
//                 <p className="card-text text-muted">Gym/Pool Attendant</p>
//                 <p className="card-text text-muted">Lobby Greeter</p>
//               </div>
//             </div>
//           </div>

//           {/* Skilled and Admin Division */}
//           <div className="col-12 col-sm-6 col-md-6 col-lg-3">
//             <div className="card text-center rounded-5 position-relative p-4">
//               <img
//                 src="/adminskill.png"
//                 className="rounded-circle"
//                 alt="Profile"
//                 style={{
//                   width: "100px",
//                   height: "100px",
//                   objectFit: "cover",
//                   position: "absolute",
//                   top: "-50px",
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                 }}
//               />
//               <div className="card-body text-start">
//                 <h5 className="card-title text-center mt-3 fw-bold fs-6">
//                   Skilled and Admin Division
//                 </h5>
//                 <p className="card-text text-muted">Engineering Staff</p>
//                 <p className="card-text text-muted">• Carpenter</p>
//                 <p className="card-text text-muted">• Painter</p>
//                 <p className="card-text text-muted">• AC Technician</p>
//                 <p className="card-text text-muted">• Electrician</p>
//                 <p className="card-text text-muted">• Mason</p>
//                 <p className="card-text text-muted">• Plumber</p>
//                 <p className="card-text text-muted">• Driver</p>
//                 <p className="card-text text-muted">Accounting/Finance Staff</p>
//                 <p className="card-text text-muted">HR Staff</p>
//                 <p className="card-text text-muted">Admin Staff</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default Divisionservice;

import React, { Component } from "react";

class Divisionservice extends Component {
  render() {
    return (
      <div className="container mt-5">
        <div className="row g-4 justify-content-center">
          {/* Food and Beverage Division */}
          <div className="col-12 col-sm-6 col-md-6 col-lg-3">
            <div className="card text-center rounded-5 position-relative p-4 mt-5">
              <img
                src="/fastfood.png"
                className="rounded-circle bg-white p-2 shadow"
                alt="Profile"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  position: "absolute",
                  top: "-50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              />
              <div className="card-body text-start">
                <h5 className="card-title text-center mt-4 fw-bold fs-6">
                  Food and Beverage Division
                </h5>
                <p className="card-text text-muted">Waiter</p>
                <p className="card-text text-muted">Waitress</p>
                <p className="card-text text-muted">Receptionist</p>
                <p className="card-text text-muted">Bartender</p>
                <p className="card-text text-muted">Barista</p>
              </div>
            </div>
          </div>

          {/* Kitchen Division */}
          <div className="col-12 col-sm-6 col-md-6 col-lg-3">
            <div className="card text-center rounded-5 position-relative p-4 mt-5">
              <img
                src="/kitchen.png"
                className="rounded-circle bg-white p-2 shadow"
                alt="Profile"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  position: "absolute",
                  top: "-50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              />
              <div className="card-body text-start">
                <h5 className="card-title text-center mt-4 fw-bold fs-6">
                  Kitchen Division
                </h5>
                <p className="card-text text-muted">
                  Kitchen Helper (Hot/Cold)
                </p>
                <p className="card-text text-muted">Butcher</p>
                <p className="card-text text-muted">Pastry</p>
                <p className="card-text text-muted">Baker</p>
                <p className="card-text text-muted">Stewards</p>
              </div>
            </div>
          </div>

          {/* Housekeeping Division */}
          <div className="col-12 col-sm-6 col-md-6 col-lg-3">
            <div className="card text-center rounded-5 position-relative p-4 mt-5">
              <img
                src="/housekeeping.png"
                className="rounded-circle bg-white p-2 shadow"
                alt="Profile"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  position: "absolute",
                  top: "-50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              />
              <div className="card-body text-start">
                <h5 className="card-title text-center mt-4 fw-bold fs-6">
                  Housekeeping Division
                </h5>
                <p className="card-text text-muted">Room Attendant</p>
                <p className="card-text text-muted">Public Area Attendant</p>
                <p className="card-text text-muted">Laundry Attendant</p>
                <p className="card-text text-muted">Linen/Uniform Attendant</p>
                <p className="card-text text-muted">Bellman</p>
                <p className="card-text text-muted">Valet Parker</p>
                <p className="card-text text-muted">Telephone Operator</p>
                <p className="card-text text-muted">Reservations Agent</p>
                <p className="card-text text-muted">Gym/Pool Attendant</p>
                <p className="card-text text-muted">Lobby Greeter</p>
              </div>
            </div>
          </div>

          {/* Skilled and Admin Division */}
          <div className="col-12 col-sm-6 col-md-6 col-lg-3">
            <div className="card text-center rounded-5 position-relative p-4 mt-5">
              <img
                src="/adminskill.png"
                className="rounded-circle bg-white p-2 shadow"
                alt="Profile"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  position: "absolute",
                  top: "-50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              />
              <div className="card-body text-start">
                <h5 className="card-title text-center mt-4 fw-bold fs-6">
                  Skilled and Admin Division
                </h5>
                <p className="card-text text-muted">Engineering Staff</p>
                <p className="card-text text-muted">• Carpenter</p>
                <p className="card-text text-muted">• Painter</p>
                <p className="card-text text-muted">• AC Technician</p>
                <p className="card-text text-muted">• Electrician</p>
                <p className="card-text text-muted">• Mason</p>
                <p className="card-text text-muted">• Plumber</p>
                <p className="card-text text-muted">• Driver</p>
                <p className="card-text text-muted">Accounting/Finance Staff</p>
                <p className="card-text text-muted">HR Staff</p>
                <p className="card-text text-muted">Admin Staff</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Divisionservice;
